import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLModels from '../components/rl/RLModels';

function ModelsPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🧠 RL Model Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Track, deploy, and manage your reinforcement learning models
        </Typography>
      </Box>

      <RLModels />
    </Container>
  );
}

export default ModelsPage;